export abstract class CookiebotConfig {
  widgetEnabled: boolean;
}
